<div class="modal-overlay" *ngIf="isOpen">
  <div class="modal">
    <!-- Barra de progreso del temporizador -->
    <div class="progress-bar">
      <div class="progress" [style.width.%]="progressPercentage"></div>
    </div>

    <div class="modal-header">
      <mat-icon>notifications_none</mat-icon>
      ¡Alerta!
      <span class="timer-text">{{ secondsLeft }}s</span>
    </div>

    <div class="modal-content">
      <p>Se requiere su atención urgente.</p>
      <p>¿Desea procesar esta alerta ahora?</p>
    </div>

    <div class="modal-actions">
      <button class="btn-cancel" (click)="close()">Cancelar</button>
      <button class="btn-accept" (click)="onTakeAlert()">Tomar alerta</button>
    </div>
  </div>
</div>
